import { detectIncognito } from 'detectincognitojs'
import { isEmpty } from 'lodash'

const headlesBrowserPermissions = async () => {
  const permissionStatus = await window.navigator?.permissions?.query({ name: 'notifications' })
  return window?.Notification?.permission === 'denied' && permissionStatus?.state === 'prompt'
}

// Detect if a the client is probably headless or incognito mode
// No reason to track these users as it will most likeyly not be possible
// and it will just cost us money
const shouldTrackUser = async () => {
  try {
    const result = {}
    if (typeof window === 'undefined' || !window?.navigator) {
      result.hasWindow = false
      result.isTrackable = false
    }
    if (window?.navigator?.webdriver) {
      result.hasWebdriver = true
      result.isTrackable = false
    }
    if (/HeadlessChrome/.test(window.navigator.userAgent)) {
      result.hasHeadlessChrome = true
      result.isTrackable = false
    }
    if (window.navigator.languages === '') {
      result.hasNoLanguages = true
      result.isTrackable = false
    }
    const [incognito, isHeadlessPermissions] = await Promise.all([detectIncognito(), headlesBrowserPermissions()])
    // Do not block incognito mode for now, they could still be identified after loggin in
    // if (incognito.isPrivate) {
    //   result.isPrivate = true
    //   result.isTrackable = false
    // }
    if (isHeadlessPermissions) {
      result.isHeadlessPermissions = true
      result.isTrackable = false
    }
    if (isEmpty(result)) {
      result.isTrackable = true
    }
    return result
  } catch (error) {
    console.error('Error in shouldTrackUser', error?.message)
    return { isTrackable: true }
  }
}

export default shouldTrackUser
